module.exports = __webpack_public_path__ + "img/logo.baeff0fb.jpg";